import { lazy } from 'react';

/**
 * Dynamic imports para componentes não críticos
 * Reduz o bundle inicial carregando sob demanda
 */

// Toast system - usado apenas quando necessário
export const DynamicToaster = lazy(() => 
  import('@/components/ui/toaster').then(module => ({ default: module.Toaster }))
);

export const DynamicSonner = lazy(() => 
  import('@/components/ui/sonner').then(module => ({ default: module.Toaster }))
);

// Analytics - carregado após interação do usuário
export const DynamicPageAnalytics = lazy(() => 
  import('@/components/PageAnalytics').then(module => ({ default: module.default }))
);

// Microsoft Clarity - carregado de forma diferida
export const loadClarityAsync = () => {
  return import('@microsoft/clarity').then(clarity => {
    try {
      clarity.default.init('szihuu7dzl');
      console.log('📊 Clarity loaded dynamically');
    } catch (error) {
      console.error('Erro ao carregar Clarity:', error);
    }
  });
};

/**
 * Preload functions - permite pré-carregar componentes antes do uso
 */
export const preloadToaster = () => import('@/components/ui/toaster');
export const preloadAnalytics = () => import('@/components/PageAnalytics');
export const preloadClarity = () => import('@microsoft/clarity');

/**
 * Hook para carregamento inteligente baseado na interação
 */
export const useIntelligentPreload = () => {
  const preloadOnHover = (component: string) => {
    switch (component) {
      case 'toaster':
        preloadToaster();
        break;
      case 'analytics':
        preloadAnalytics();
        break;
      case 'clarity':
        preloadClarity();
        break;
      default:
        break;
    }
  };

  const preloadOnClick = (component: string) => {
    // Preload imediato para uso rápido
    return preloadOnHover(component);
  };

  return { preloadOnHover, preloadOnClick };
};
